import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators, FormBuilder, ValidatorFn } from '@angular/forms';
import { noFutureDate, noPastDate } from '@bookinglab/ui';
import { ApiService } from './api.service';
import { DatastoreService } from './datastore.service';
import { CommonFunctionsService } from './common-functions.service';
import * as _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class FormBuilderService {

  constructor(
    public dataStore: DatastoreService,
    private commonFunctionsService: CommonFunctionsService,
    private apiService: ApiService,
    private formBuilder: FormBuilder
  ) { }

  questions: any = {};
  forms: any = {};
  schema: any = {};

  async buildForm(formId: string, formValues: any[], childIndex: Number): Promise<FormGroup<any>> {
    const schema: any = await this.apiService.getFormSchema(formId) as any;
    console.log(schema);
    // remove haf id
    let foundKey = -1;
    for (const [idx, field] of schema.schema.fields.entries()) {
      // console.log(idx, field);
      if (field.field === 'haf_id') {
        foundKey = idx;
        break;
      }
    }
    if (foundKey > -1) {
      schema.schema.fields.splice(foundKey, 1);
    }
    const formGroup: FormGroup = new FormGroup({});
    this.schema[formId] = schema;
    this.dataStore.schema = schema
    if (schema.schema) {

      this.questions[formId] = schema.schema.fields;

      for (const field of schema.schema.fields) {
        let validators = (field.required) ? Validators.required : undefined;
        // RPD-20: hide_dates_in_future/past must live on the control, not just
        // on a max/min attribute, so a keyboard-entered date is validated too.
        // These go on the combined field control ONLY — the y/m/d controls
        // created below hold bare numbers, which are not dates.
        const dateRange = this.dateRangeValidators(field);
        const fieldValidators: ValidatorFn[] = [
          ...(validators ? [validators] : []),
          ...dateRange,
        ];
        const foundField = formValues.find((f) => f.field === field.field);
        let f: any = false;
        if (foundField) {
          if (field.type !== 'radio') {
            f = new FormControl(foundField.value, (!field.conditional) ? fieldValidators : dateRange);
          }
          else {
            f = new FormControl(foundField.value.toString(), (!field.conditional) ? fieldValidators : dateRange);
          }
        }
        else {
          if (field.type !== 'upload') {
            f = new FormControl('', (!field.conditional) ? fieldValidators : dateRange);
          }
          else {
            f = this.formBuilder.array([]);
          }

        }
        formGroup.addControl(field.field, f);

        if (field.type == 'date') {
          const dateY = new FormControl('', validators);
          const dateM = new FormControl('', validators);
          const dateD = new FormControl('', validators);
          formGroup.addControl(field.field + 'y', dateY);
          formGroup.addControl(field.field + 'm', dateM);
          formGroup.addControl(field.field + 'd', dateD);
        }
      }
    }
    // console.log(`${formId}_${childIndex}`, formGroup)
    this.forms[`${formId}_${childIndex}`] = formGroup;
    return formGroup;
  }

  createItem(data: any): FormGroup {
    return this.formBuilder.group(data);
  }


  /**
   * RPD-20: the date range validators implied by the question schema flags.
   * Only ever applied to a field's combined YYYY-MM-DD control.
   */
  dateRangeValidators(field: Record<string, any>): ValidatorFn[] {
    const validators: ValidatorFn[] = [];
    if (field['hide_dates_in_future']) {
      validators.push(noFutureDate());
    }
    if (field['hide_dates_in_past']) {
      validators.push(noPastDate());
    }
    return validators;
  }

  getFields(formId: string) {
    try {
      return this.questions[formId];
    }
    catch (err) {
      return [];
    }
  }

  getDetailsTitle(formId: string) {
    if (this.schema.hasOwnProperty(formId)) {
      if (this.schema[formId].schema.hasOwnProperty('form_name')) {
        return this.schema[formId].schema.form_name;
      }
    }
    return 'Test form';
  }

  getParentField(formId: string, field: any) {
    if (field.field) {
      if (field.type == 'checkbox') {
        if (field.checkbox_field) {
          const found = this.questions[formId].find((f: any) => f.field == field.checkbox_field);
          if (found) {
            return found;
          }
        }
      }
    }
    return {};
  }

  // getTriggerField(formId: string, field: any) {
  //   if (field.field) {
  //     // if (field.type == 'checkbox') {
  //     //   if (field.checkbox_field) {
  //     //     const found = this.questions[formId].find((f: any) => f.field == field.trigger);
  //     //     if (found) {
  //     //       return found;
  //     //     }
  //     //   }
  //     // }
  //     // else {
  //       const found = this.questions[formId].find((f: any) => f.field == field.trigger);
  //       if (found) {
  //         return found;
  //       }
  //     }
  //   // }
  //   return {};
  // }


  getTriggerField(formId: string, field: any, trigger: string) {
    if (field.field) {
      if (field.type == 'checkbox') {
        const found = this.questions[formId].find((f: any) => f.field == trigger);
        if (found) {
          return found;
        }
      }
      else {
        const found = this.questions[formId].find((f: any) => f.field == trigger);
        if (found) {
          return found;
        }
      }
    }
    return {};
  }

  // shouldShowConditional(formId: string, field: any, idx: Number): boolean {
  //   if (field.conditional) {
  //     const parent = this.getTriggerField(formId, field);
  //     const parentForm = this.forms[`${formId}_${idx}`];
  //     if (parentForm.get(parent.field) === null || parentForm.controls[field.field] === undefined) {
  //       return false
  //     } else {
  //       // despite being called trigger_value, trigger_value can be an array of trigger values
  //       let trigger_values = field.trigger_value
  //       if (!(trigger_values instanceof Array)) {
  //         trigger_values = [trigger_values]
  //       }
  //       let triggerValue;
  //       for (let trigger_value of trigger_values) {
  //         if (parent.type == 'checkbox') {
  //           triggerValue = trigger_value;
  //         } else {
  //           triggerValue = `${trigger_value}`;
  //         }
  //         if (parentForm.get(parent.field).value === triggerValue) {
  //           if (parentForm.controls[field.field].status === "DISABLED") {
  //             parentForm.controls[field.field].enable();
  //           }
  //           return true;
  //         }
  //       }

  //       if (parentForm.controls[field.field].status !== "DISABLED") {
  //         if(field.type !== "upload"){
  //           parentForm.controls[field.field].setValue("")
  //         } else{
  //           parentForm.controls[field.field].setValue([])
  //         }
  //         parentForm.controls[field.field].disable();
  //       }
  //       return false;
  //     }
  //   }
  //   else {
  //     return true;
  //   }

  // }

  shouldShowConditional(formId: string, field: any, parentForm: any, configControlConditional:boolean = true): boolean {
    if (field.conditional) {
      let results = []; // see line 182
      let totalTrueRequired: any = {};
      const triggerFields = field.trigger.split("|");
      totalTrueRequired[field.field] = 0;

      let triggerTmpValue = field.trigger_value;
      if (typeof triggerTmpValue !== 'string') {
        triggerTmpValue = `${triggerTmpValue}`;
      }
      const triggerExpressions = triggerTmpValue.split("|");
      let retVal = false;
      let i = 0;
      for (const trigger of triggerFields) {
        const parent = this.getTriggerField(formId, field, trigger);
        if (parent && parent.field) {
          let triggerValueStr = triggerExpressions[i];
          const config = JSON.parse(this.dataStore.config);
        
          if(config?.hiddenChildFormQuestions && configControlConditional){
            if (config?.hiddenChildFormQuestions[parent.field]) {
              return true
            }
          }
          // do we have a multi-part condition?
          const parts = triggerValueStr.split("&");
          for (const triggerValue of parts) {
            totalTrueRequired[field.field] += 1; // add the conditions to field
            if (["<", ">", "!"].indexOf(triggerValue[0]) !== -1) {
              // let val = false;
              const trigger: number = parseInt(triggerValue.substr(1));
              let parentFieldValue = parentForm.get(parent.field).value;
              // console.log(field.field + " trigger field:" + trigger, "Expression: " + triggerValue, "parent", parent.field, "parent val: ", parentFieldValue);

              let doSwitch = true;

              // In this switch statement I changed the value to be an array for multipart questions.
              // The array is summed up to check if there is any truthy values, if there are then true is returned
              // did this because if a trigger value of "<18&>15|no" where only the first trigger part is true the second runs
              // last and therefor is the returned value of false. 

              switch (triggerValue[0]) {
                case "<":
                  if (parentFieldValue < trigger) {
                    // val = true;
                    results.push(true);
                  }
                  break;
                case ">":
                  if (parentFieldValue > trigger) {
                    // val = true;
                    results.push(true);
                  }
                  break;
                case "!":
                  if (parentFieldValue !== trigger) {
                    // val = true;
                    results.push(true);
                  }
                  break;
                default:
                  // val = false;
                  results.push(false);
              }
              // if (!val) {
              //   break; // This loop is an AND
              // }
            } else{
              let parentFieldValue = parentForm.get(parent.field).value;
              if(parentFieldValue === triggerValueStr){
                results.push(true);
              }
            }
            // console.log('val', results);
            // retVal = val;
            // retVal = results.some((e: any) => e === true);
          }
        }
        i++;
      }
      // console.log(field.field, "retVal", retVal);

      // store errors to replace if a form is enabled
      let tempErrorStore = parentForm.controls[field.field]?.errors;
      if (triggerTmpValue.includes("&")) {
        // its multi conditional which means we can reduce the truth flag by 1 as its an OR
        totalTrueRequired[field.field] = (totalTrueRequired[field.field] - 1);
      }

      // Count the true conditions we have
      let trueCount = results.filter(value => value === true).length;
      // if (field.field == "child_postcode") {
      //   console.log(`question ${field.field} : true count: ${trueCount}`);
      //   console.log(`true count required: ${totalTrueRequired[field.field]}`);
      //   console.log(`-----------------------------------------------`);
      // }

      // If the true count matches the amount of conditions we have, it means
      // the trigger statement is true
      if (trueCount >= 1) {
        retVal = true;
      } else {
        retVal = false;
      }

      if (retVal) { // disable fields that are not visible
        if (parentForm.controls[field.field].status === "DISABLED") {
          parentForm.controls[field.field].enable();
          parentForm.controls[field.field].setValidators([
            ...((field.required) ? [Validators.required] : []),
            ...this.dateRangeValidators(field),
          ]);
          parentForm.controls[field.field].updateValueAndValidity({onlySelf: true});
          // console.log(parentForm.controls[field.field]);
        }
      } else {
        // console.log('parentForm', parentForm, 'field', field, 'ctrl', parentForm.controls[field.field]);
        if (parentForm.controls[field.field].status !== "DISABLED") {
          // parentForm.controls[field.field].setValue("")
          parentForm.controls[field.field].markAsPristine()
          parentForm.controls[field.field].markAsUntouched()
          parentForm.controls[field.field].disable();
          parentForm.controls[field.field].setValidators(undefined);
          parentForm.controls[field.field].updateValueAndValidity({onlySelf: true});
          tempErrorStore = null;
        }
      }
      parentForm.controls[field.field].errors = tempErrorStore;
      // console.log(formId,field,retVal)

      return retVal;
    } else {
      return true;
    }

  }

}
